import { Button, Image } from 'antd';
import styled from 'styled-components';
import {
    blue01,
    blue02,
    blue,
    blueDark03,
    blueDark01,
    grayDark03,
    grayDark06,
    grayLight04,
} from '../../../styles/colors';

export const AddProductButton = styled(Button)`
    margin-left: 5px;
    border-radius: 3px;
    background-color: ${blue01};
    color: #ffffff;
    cursor: pointer;
    border-color: ${blue01};
    border-radius: 3px 0 0 3px;
    &:focus {
        background-color: ${blue01};
        color: #ffff;
    }

    &:disabled {
        border-radius: 3px;
        border-color: ${blue01};
        color: #ffffff;
        background-color: ${blue01};
        opacity: 0.3;
    }

    &.add-selections-button {
        border-radius: 3px !important;
    }
`;

export const AddProductMenu = styled(Button)`
    border-radius: 0px 3px 3px 0;
    padding: 0 10px;
    background-color: ${blue01};
    border-color: ${blue01} ${blue01} ${blue01} rgba(255, 255, 255, 0.3);
    &:focus {
        background-color: ${blue};
        color: #ffff;
        border-color: #ffff;
    }
`;

export const AddProductButtonContainer = styled('div')`
    &:hover {
        button:first-child {
            background-color: ${blue02};
            color: #ffff;
        }
        button:last-child {
            background-color: ${blue02};
            color: #ffff;
        }
    }
`;

export const ProductsActionImage = styled(Image)`
    padding: 10px;
    cursor: pointer;
    border-radius: 3px;
    &:hover {
        background-color: ${blueDark03};
    }
    &:focus {
        background-color: ${blueDark01};
    }
    &.disabled {
        opacity: 0.3;
        &:hover {
            background-color: transparent;
        }
    }
`;

// The dropdown renders in a portal, so it is styled by wrapping the menu via Dropdown's dropdownRender.
export const AddProductsDropdownMenu = styled('div')`
    ul.ant-dropdown-menu {
        display: flex;
        flex-direction: column;
        gap: 4px;
        width: 287px;
        padding: 4px;
        border: 1px solid ${grayDark06};
        border-radius: 3px;
        box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.12);

        > .ant-dropdown-menu-item-divider {
            margin: 0 12px;
        }
    }

    .ant-dropdown-menu-item-divider {
        background-color: #d9d9d9;
    }

    .ant-dropdown-menu-item-group-title {
        padding: 12px 12px 0;
        font-family: 'Proxima N W15 Bold';
        font-size: 14px;
        line-height: 18px;
        color: rgba(0, 0, 0, 0.85);
    }

    .ant-dropdown-menu-item-group-list {
        display: flex;
        flex-direction: column;
        gap: 4px;
        margin: 4px 0 0 12px;

        .ant-dropdown-menu-item-divider {
            margin: 0 20px 0 12px;
        }
    }

    .ant-dropdown-menu-item {
        display: flex;
        align-items: center;
        height: 36px;
        padding: 0 12px;
        border-radius: 3px;
        font-family: 'Proxima Nova';
        font-size: 14px;
        line-height: 18px;
        color: rgba(0, 0, 0, 0.85);

        &:hover {
            background-color: ${grayLight04};
            color: ${blueDark01};
        }
    }

    .add-products-delete-item {
        color: ${grayDark03};
    }

    .ant-dropdown-menu-item-disabled,
    .ant-dropdown-menu-item-disabled:hover {
        background-color: transparent;
        opacity: 0.3;
        cursor: not-allowed;
    }

    .add-products-live-guideline {
        display: inline-flex;
        align-items: center;
        gap: 4px;

        img {
            width: 14px;
            height: 14px;
        }
    }
`;
